global.__DEV__ = (() => {
  try {
    return __DF_DEV__ === 'true' || __DF_DEV__ === true;
  } catch (_) {
    return false;
  }
})();

global.__DEBUG__ = (() => {
  try {
    return __DF_DEBUG__ === 'true' || __DF_DEBUG__ === true;
  } catch (_) {
    return false;
  }
})();
